import "./EventCard.scss";
import { baseUrl } from "../../../utils/apiData";
import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";

const EventCard = ({ data }) => {
  console.log(data);
  return (
    <div className="event_card wow fadeInUp">
      <div className="img_wrap">
        <img src={`${baseUrl}/${data?.image}`} alt="event" />
      </div>
      <div className="text_part">
        <div className="left">
          <div className="tag_title">
            <div className="tag">{data?.category?.category_name || "-"}</div>
            <h4>{data?.button_name || "-"}</h4>
          </div>
        </div>
        <a href={data?.link} target="_target">
          <ArrowBtn text={data?.button_name || "-"} theme="white_secondary" />
        </a>
      </div>
    </div>
  );
};

export default EventCard;
